import React, {ReactNode} from 'react';
import CLModal, {CLModalProps} from '../CLModal/CLModal';
import './CLActionModal.module.scss';
import classNames from 'classnames';
import CLActionModalFooter from './Footer/CLActionModalFooter';
import styles from './CLActionModal.module.scss';

interface CLActionModalProps extends CLModalProps {
  okLabel?: string;
  isOkDisabled?: boolean;
  cancelLabel?: string;
  isCancelDisabled?: boolean;
  isShowCancel?: boolean;
  modalAction?: () => Promise<unknown>;
  clearContentBottomPadding?: boolean;
  isExecuting?: boolean;
  modalClassName?: string;
  isUserMissingPermission?: boolean;
  okButtonTooltip?: ReactNode;
  modalFooter?: ReactNode;
}

export default function CLActionModal({
  className = '',
  bodyClassName = '',
  modalClassName,
  children,
  isShowCancel = true,
  onCancel,
  cancelLabel,
  okLabel,
  modalAction,
  isOkDisabled,
  isCancelDisabled,
  clearContentBottomPadding = true,
  isExecuting,
  isUserMissingPermission,
  okButtonTooltip,
  modalFooter,
  ...otherModalProps
}: CLActionModalProps) {
  const hasActions = modalAction || isShowCancel;

  return (
    <CLModal
      {...otherModalProps}
      className={className}
      bodyClassName={classNames(styles.common_cl_action_modal, styles.modal_body, modalClassName)}
      onCancel={onCancel}
      modalFooter={
        modalFooter ??
        (hasActions ? (
          <CLActionModalFooter
            isExecuting={isExecuting}
            isShowCancel={isShowCancel}
            okLabel={okLabel}
            cancelLabel={cancelLabel}
            modalAction={modalAction}
            onCancel={onCancel}
            isOkDisabled={isOkDisabled}
            isCancelDisabled={isCancelDisabled}
            isUserMissingPermission={isUserMissingPermission}
            okButtonTooltip={okButtonTooltip}
            qaHook={otherModalProps.qaHook}
          />
        ) : null)
      }
    >
      <div
        className={classNames(styles.modal_body_content, bodyClassName, {
          no_buttons: !hasActions,
          [styles.clear_bottom]: clearContentBottomPadding,
        })}
      >
        {children}
      </div>
    </CLModal>
  );
}

export {CLActionModalProps};
